/*
  Zain Art V3 - Intersection Observer Lazy Loader (theme-observer.js)
*/

class ZainArtIntersectionObserver {
  constructor() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.triggerLoad(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '100px' });
  }

  observe(element, callback) {
    if (!element) return;
    element._ZainArt_obs_cb = callback;
    this.observer.observe(element);
  }

  triggerLoad(element) {
    if (typeof element._ZainArt_obs_cb === 'function') {
      element._ZainArt_obs_cb(element);
    }
  }
}

window.ZainArtObserverClass = ZainArtIntersectionObserver;
